import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { List, X, Phone } from "@phosphor-icons/react";
import { CONTACT } from "../lib/constants";

const NAV = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Estimator", href: "#estimator" },
  { label: "Areas", href: "#areas" },
  { label: "Journal", href: "#journal" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-[#F2F2EF]/95 backdrop-blur-xl border-b-2 border-[#111]" : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-5 md:px-10 lg:px-16 py-4">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2 group">
          <span className="w-2 h-2 bg-[#D85C3A]" />
          <span className="font-display text-xl md:text-2xl tracking-tighter">
            THE&nbsp;MELBOURNE&nbsp;<span className="text-[#D85C3A]">PAINTERS</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm font-bold uppercase tracking-widest hover:text-[#D85C3A] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${CONTACT.phone}`}
            data-testid="header-call-btn"
            className="hidden md:flex items-center gap-2 text-sm font-bold uppercase tracking-widest hover:text-[#D85C3A]"
          >
            <Phone size={18} weight="duotone" /> {CONTACT.phoneDisplay}
          </a>
          <a href="#book" data-testid="header-quote-btn" className="hidden sm:inline-flex btn-brut text-sm py-3 px-5">
            Free Quote
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden border-2 border-[#111] p-2"
            onClick={() => setOpen((o) => !o)}
            aria-label="menu"
          >
            {open ? <X size={22} /> : <List size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#F2F2EF] border-t-2 border-[#111] px-5 py-6 slide-up">
          <div className="flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={() => setOpen(false)}
                className="font-display text-3xl tracking-tight hover:text-[#D85C3A]"
              >
                {n.label}.
              </a>
            ))}
            <a href={`tel:${CONTACT.phone}`} className="btn-brut justify-center mt-4">
              <Phone size={20} weight="duotone" /> Call {CONTACT.phoneDisplay}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
